<template>
  <div class="q-pa-lg" style="">
    <div>
      <el-form ref="queryParams" :model="queryParams" :inline="true" size="small">
        <el-form-item>
          <el-input v-model.trim="queryParams.iccid" placeholder="ICCID/我方卡号/上游卡号" />
        </el-form-item>
        <el-form-item>
        <el-select  clearable filterable allow-create default-first-option v-model="queryParams.cardType"  placeholder="资源类型">
          <el-option v-for="(item,index) in cardTypes" :key="index" :label="item.cardTypeName" :value="item.cardTypeCode">
          </el-option>
        </el-select>

      </el-form-item>

        <el-form-item v-if="roleId==='777' || roleId==='619285375' ">
          <el-select  clearable filterable allow-create default-first-option v-model="queryParams.relatedCdId"  placeholder="通道类型">
            <el-option v-for="(item,index) in cardRoutes" :key="index" :label="item.cdName" :value="item.cdId">
            </el-option>
          </el-select>

        </el-form-item>


        <el-form-item v-if="username!=='南京杭兆坤'">
          <el-select clearable filterable allow-create default-first-option v-model="queryParams.agentId" placeholder="代理选择">
            <el-option v-for="(i,index) in agents" :key="index+'q'" :label="i.agentName" :value="i.agentId">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item v-show="isShow">
          <el-select clearable v-model="queryParams.status" placeholder="卡状态" style="width: 200px">
            <el-option :value="0" label="待激活"/>
            <el-option :value="1" label="正常" />
            <el-option :value="2" label="停机" />
            <el-option :value="3" label="测试激活"/>
            <el-option :value="4" label="测试去激活"/>
            <el-option :value="5" label="已失效"/>
            <el-option :value="6" label="运营商管理状态"/>
            <el-option :value="7" label="拆机"/>
            <el-option :value="8" label="库存"/>
            <el-option :value="9" label="可测试"/>
            <el-option :value="10" label="已清除"/>
            <el-option :value="11" label="已更换"/>
            <el-option :value="12" label="已销户"/>
            <el-option :value="13" label="预销户"/>
          </el-select>
        </el-form-item>

        <el-form-item v-if="isShow">
          <el-select clearable filterable allow-create default-first-option v-model="queryParams.classification" placeholder="分类选择">
            <el-option v-for="(item,index) in classification_list" :key="index+'r'" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-show="isShow">
          <el-input v-model="queryParams.startIccid" placeholder="开始卡号" />
        </el-form-item>
        <el-form-item v-show="isShow">
          <el-input v-model="queryParams.endIccid" placeholder="结束卡号" />
        </el-form-item>



        <el-form-item>
          <el-button type="primary" plain size="small" style="padding-left: 10px" @click="list(1)"  icon="el-icon-search">
            搜索
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" plain style="padding-left: 10px;" @click="resetForm('queryParams')" >
            重置
          </el-button>
        </el-form-item>
        <el-form-item v-if="roleId==='777' || roleId==='619285375'">
          <el-button type="primary" plain size="small"  @click="importCard"  icon="el-icon-upload">导卡
          </el-button>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" plain size="small" @click="exportExcel"  icon="el-icon-download">导出</el-button>
        </el-form-item>

        <el-form-item v-if="roleId==='777' || roleId==='619285375' || roleId==='5' &&username!=='南京杭兆坤'" >
          <el-button  type="primary" plain size="small" @click.prevent="allocopen"  icon="el-icon-sold-out">分配套餐</el-button>
        </el-form-item>

        <el-form-item v-if="roleId==='777' || roleId==='619285375' " @click.native="openUpdInfo=true">
          <el-button type="primary" plain size="small" icon="el-icon-edit">修改分类</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" plain style="padding-left: 10px;" @click="showToggle">
            更多
          </el-button>
        </el-form-item>

      </el-form>

    </div>

      <el-table
                ref="multipleTable" :data="tableData" :row-style="{height:'40px'}"
                :cell-style="{height:'5px,0',textAlign:'center'}"
                :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                border  @sort-change="sortchange" style="width: 100%;height: 70vh;">
        <el-table-column type="selection" min-width="15%">
        </el-table-column>

        <el-table-column  show-overflow-tooltip  label="诊断" width="80">
          <template slot-scope="{row}">
            <i @click="toDiasrelin(row.iccid)" class="el-icon-data-line" style="color: rgb(64, 158, 255);font-size: 20px"/>
          </template>

        </el-table-column>

        <el-table-column show-overflow-tooltip :label="roleId==='777'?'ICCID':'我方卡号'" width="180">
          <template slot-scope="scope">
            <span style="color: #409EFF;cursor: pointer" @click="openCardInfo(scope.row)">{{roleId==='777'?scope.row.iccid:scope.row.cardDefineNo}}</span>
          </template>
        </el-table-column>

        <!--<el-table-column v-if="roleId==='777'"  show-overflow-tooltip prop="cardNo" label="上游卡号" width="170">
        </el-table-column>-->

        <el-table-column show-overflow-tooltip prop="isRealname" label="实名状态" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isRealname===0">未实名</div>
            <div v-if="scope.row.isRealname===1">审核中</div>
            <div v-if="scope.row.isRealname===2">已实名</div>
            <div v-if="scope.row.isRealname===3">恶意实名</div>
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip  label="套餐详情" width="80">
          <template slot-scope="scope">
            <el-button @click="optino_SetMeal(scope.row)" type="primary" round plain size="small">查看</el-button>
          </template>
        </el-table-column>

        <el-table-column v-if="roleId==='777' || roleId==='619285375'"  show-overflow-tooltip prop="cardTypeName" label="资源通道" width="170">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" label="导入时间" width="170">
        </el-table-column>

        <el-table-column show-overflow-tooltip prop="agentName" label="代理商" width="100" v-if="username!=='南京杭兆坤'">
        </el-table-column>
        <el-table-column  prop="remain" label="剩余流量" sortable width="120">
          <template slot-scope="scope">
            {{scope.row.remain}}
          </template>
        </el-table-column>

        <el-table-column  prop="used" label="已用流量"  sortable width="120">
          <template slot-scope="scope">
            {{scope.row.used}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100" v-if="cardType.endsWith('c') || cardType.endsWith('wh') ||typeWh.endsWith('wh') " label="通话总数" prop="totalVoice">
          <template slot-scope="scope">
            {{scope.row.totalVoice}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100" v-if="cardType.endsWith('c') || cardType.endsWith('wh') ||typeWh.endsWith('wh')" label="已用通话" prop="usedVoice">
          <template slot-scope="scope">
            {{scope.row.usedVoice}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100" v-if="cardType.endsWith('wh') || typeWh.endsWith('wh')" label="剩余通话" prop="remainVoice">
          <template slot-scope="scope">
            {{scope.row.remainVoice}}
          </template>
        </el-table-column>


        <el-table-column show-overflow-tooltip prop="xkStatus" label="卡状态" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.status===100" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">异常</span>
            </div>
            <div v-if="scope.row.status===99" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">更新中</span>
            </div>
            <div v-if="scope.row.status===0" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">待激活</span>
            </div>
            <div v-if="scope.row.status===1" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: green;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">正常</span>
            </div>
            <div v-if="scope.row.status===2" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #fe1611;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">停机</span>
            </div>
            <div v-if="scope.row.status===3" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">测试激活</span>
            </div>
            <div v-if="scope.row.status===4" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 18%;border-radius: 50%"></div>
              <span style="margin-left: 15%">测试去激活</span>
            </div>
            <div v-if="scope.row.status===5" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">已失效</span>
            </div>
            <div v-if="scope.row.status===6" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #deb887;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">运营商管理</span>
            </div>
            <div v-if="scope.row.status===7" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">拆机</span>
            </div>
            <div v-if="scope.row.status===8" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">库存</span>
            </div>
            <div v-if="scope.row.status===9" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">可测试</span>
            </div>
            <div v-if="scope.row.status===10" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">已清除</span>
            </div>
            <div v-if="scope.row.status===12" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">已销户</span>
            </div>
            <div v-if="scope.row.status===13" style="display: inline-flex;width: 100%">
              <div style="width: 10px;height: 10px;background-color: #222933;margin-top: 15%;border-radius: 50%"></div>
              <span style="margin-left: 15%">预销户</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="lastEndTime" label="套餐到期时间" width="170">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="roundTime" label="轮巡时间" width="170">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="balance" label="余额" width="100">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="classification" label="分类" width="150">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="remarks" label="备注" width="150">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" min-width="150" fixed="right">
          <template slot-scope="scope">
            <el-dropdown @command="handlerCommand">
              <el-button type="primary" plain size="small">操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand(scope.row,'upFlow',scope.$index)" :key="0">更新流量
                </el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(scope.row,'status',scope.$index)" :key="1">更新状态
                </el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(scope.row,'auth',scope.$index)" :key="2">查询实名
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.cardType.lastIndexOf('c')==-1" :command="beforeHandleCommand(scope.row,'on',scope.$index)" :key="3">复机指令
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.cardType.lastIndexOf('c')==-1" :command="beforeHandleCommand(scope.row,'off',scope.$index)" :key="4">停机指令
                </el-dropdown-item>
                <!--<el-dropdown-item :command="beforeHandleCommand(scope.row,'iotFlow',scope.$index)" :key="5">
                  真实用量
                </el-dropdown-item>-->
<!--                <el-dropdown-item :command="beforeHandleCommand(scope.row,'plus',scope.$index)" :key="6">人工充值-->
<!--                </el-dropdown-item>-->
<!--                <el-dropdown-item :command="beforeHandleCommand(scope.row,'mins',scope.$index)" :key="7">人工扣费-->
<!--                </el-dropdown-item>-->
                <el-dropdown-item :command="beforeHandleCommand(scope.row,'payPassword',scope.$index)" :key="8">
                  支付密码
                </el-dropdown-item>
                <el-dropdown-item v-if="(roleId==='777' || roleId==='619285375') && scope.row.cardType.lastIndexOf('c')===-1  "
                                  :command="beforeHandleCommand(scope.row,'changeAuth',scope.$index)" :key="9">修改实名
                </el-dropdown-item>
                <el-dropdown-item v-if="(roleId==='777' || roleId==='619285375') && scope.row.cardType.endsWith('dx')"
                                  :command="beforeHandleCommand(scope.row,'cleanAuth',scope.$index)" :key="10" style="color:  #FF0000;">清除实名
                </el-dropdown-item>
                <el-dropdown-item v-if="roleId==='777' || roleId==='619285375'"
                                  :command="beforeHandleCommand(scope.row,'refurbishCard',scope.$index)" :key="11" style="color:  #FF0000;">翻新卡
                </el-dropdown-item>
                <el-dropdown-item v-if="roleId==='777' || roleId==='619285375'"
                                  :command="beforeHandleCommand(scope.row,'deleteCard',scope.$index)" :key="12" style="color:  #FF0000;">删除卡
                </el-dropdown-item>
                <el-dropdown-item v-if="username=='南京杭兆坤' ||username=='青岛中瑞' "
                                  :command="beforeHandleCommand(scope.row,'CMPPClient',scope.$index)" :key="12" style="color:  #FF0000;">发送短信
                </el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>

    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>





    <!--修改分类及备注-->
    <el-dialog v-if="roleId==='777'|| roleId==='619285375'" :close-on-click-modal="false" :visible.sync="openUpdInfo" title="修改分类及备注" class="class_dialog_hospital" width="50%">
      <el-form label-width="80px">
        <el-form-item label="ICCID：" >
          <el-input style="" maxlength="100000" type="textarea"
                    :rows="10" placeholder="此处填写操作的ICCID，多个号码请使用英文逗号隔开" v-model="updInfo.iccids">
          </el-input>
        </el-form-item>
        <el-form-item label="分类编辑 :">
          <el-input placeholder="自定义" v-model.trim="updInfo.classification"  />
        </el-form-item>
        <el-form-item label="备注 :">
          <el-input placeholder="自定义" v-model.trim="updInfo.remarks" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openUpdInfo = false">取 消</el-button>
        <el-button size="small" @click="updInfoOK" type="primary">确认</el-button>
      </div>

    </el-dialog>


    <alloc-package v-if="roleId==='777'|| roleId==='619285375' || roleId==='5'" :append-to-body="true" :diaVisDrawCard="diaVisDrawCard" :key="aollpackey" ></alloc-package>






    <el-dialog v-if="roleId==='777'|| roleId==='619285375'" :close-on-click-modal="false" title="导卡入库" :visible.sync="diaVisImport" class="class_dialog_hospital" width="50%">
      <!--<el-progress :text-inside="true" :stroke-width="20" :percentage="pressnum"></el-progress>-->
      <span>下载模板：<a :href="importUrl">导入模板</a></span>
      <el-upload :disabled="false" ref="upload" style="text-align: center"
                 class="upload-demo" drag
                 :action="uploadUrl"
                 multiple
                 :limit=limitNum :auto-upload="false"
                 :on-change="this.$upload.onChange"
                 :before-upload="this.$upload.beforeUpload"
                 :on-exceed="this.$upload.onExcced"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :headers="headers"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div style="text-align: center">
        <el-button style="" size="small" plain type="primary" @click="uploadFile">开始上传</el-button>
        <el-button style="" size="small" plain type="info" @click="diaVisImport=false">取消上传</el-button>
      </div>

    </el-dialog>

    <el-dialog v-if="roleId==='777'|| roleId==='619285375'" :close-on-click-modal="false" title="请增加资源所属地区" :visible.sync="diaVisCard" class="class_dialog_hospital" width="50%">
      <el-form :model="resourceForm" :rules="rules" ref="resourceForm">
        <el-form-item label="资源名称" prop="cardTypeName">
          <el-input placeholder="比如：**电信" v-model.trim="resourceForm.cardTypeName" />
        </el-form-item>
        <el-form-item class="wrapper" label="资源代码（注意：此代码为导卡表里面的 card_type）" prop="cardTypeCode">
          <el-input @blur="blurCardType" placeholder="比如：lcdx(聊城电信)" v-model.trim="resourceForm.cardTypeCode" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diaVisCard=false">取 消</el-button>
        <el-button type="primary" @click="saveResource('resourceForm')">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :close-on-click-modal="false" title="物联网卡详情" :visible.sync="cardInfoDis" :modal-append-to-body="false" class="class_dialog_hospital" width="60%">
      <el-form label-width="120px" style="border: 1px solid rgba(210,137,255,0.2)">
        <el-form-item style="font-weight: 600" label="基本信息："></el-form-item>
        <div style="display: flex">
          <el-form-item label="我方卡号：">
            <el-input v-model="cardInfo.cardDefineNo" disabled />
          </el-form-item>
          <el-form-item v-if="roleId==='777'|| roleId==='619285375'"  label="上游卡号：">
            <el-input v-model="cardInfo.cardNo" disabled />
          </el-form-item>
          <el-form-item v-if="roleId==='777'|| roleId==='619285375'" label="ICCID：">
            <el-input v-model="cardInfo.iccid" disabled />
          </el-form-item>
        </div>
      </el-form>

      <el-form label-width="120px" style="border: 1px solid rgba(210,137,255,0.2);margin-top: 2%">
        <el-form-item  label="套餐包：" style="font-weight: 600">
          <el-tag style="margin-left: 1%" type="info" v-for="(item,index) in cardInfo.packetNameList" :key="index">{{item.packetWxName}}({{packageId}})</el-tag>
        </el-form-item>
      </el-form>

      <el-form v-if="roleId==='777'|| roleId==='619285375'" label-width="120px" style="border: 1px solid rgba(210,137,255,0.2);margin-top: 2%">
        <el-form-item style="font-weight: 600" label="身份信息："></el-form-item>
        <div style="display: flex;">
            <el-form-item label="真实姓名："  >
              <el-input v-if="cardInfo.realName !==''" v-model="cardInfo.realName" disabled />
              <el-input v-else v-model="无" disabled />
            </el-form-item>
            <el-form-item label="身份证：" >
              <el-input v-if="cardInfo.idCardNo !== ''" v-model="cardInfo.idCardNo" disabled />
              <el-input v-else v-model="无" disabled />
            </el-form-item>
            <el-form-item label="手机号：" >
              <el-input v-if="cardInfo.mobile !==''"  v-model="cardInfo.mobile" disabled />
              <el-input v-else v-model="无" disabled />
            </el-form-item>
          </div>
      </el-form>

      <el-form label-width="120px" style="border: 1px solid rgba(210,137,255,0.2);margin-top: 2%">
        <el-form-item style="font-weight: 600" label="管控信息："></el-form-item>
        <div style="display: flex;">
          <el-form-item v-if="roleId==='777' || roleId==='619285375'" label="通道名称：" >
            <el-input v-if="cardInfo.relatedCdId !== null" v-model="cardInfo.cdName" disabled />
            <el-input v-else v-model="无" disabled />
          </el-form-item>
          <el-form-item  label="是否轮询："  >
            <el-input v-if="cardInfo.isPolling===0" v-model="no" disabled />
            <el-input v-if="cardInfo.isPolling===1" v-model="yes" disabled />
          </el-form-item>
          <el-form-item v-if="roleId==='777' || roleId==='619285375'" label="达量阈值(MB)：">
            <el-input v-model="cardInfo.offNetUse===null?'无':cardInfo.offNetUse" disabled />
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item v-if="roleId==='777' || roleId==='619285375'" label="限速规则(MB)：">
            <el-input v-model="cardInfo.isLimitRules" disabled v-if="cardInfo.isLimitRules !==''" />
            <el-input v-model="wu" disabled v-if="cardInfo.isLimitRules ==''" />
          </el-form-item>
          <el-form-item v-if="roleId==='777' || roleId==='619285375'" label="自定义金额：">
              <el-input v-model="cardInfo.diyBalance" disabled v-if="cardInfo.diyBalance !==''" />
              <el-input v-model="wu" disabled v-if="cardInfo.diyBalance ==''" />
          </el-form-item>
        </div>
      </el-form>

      <el-form label-width="120px" style="border: 1px solid rgba(210,137,255,0.2);margin-top: 2%">
        <el-form-item style="font-weight: 600" label="功能信息："></el-form-item>
          <el-form-item label="销户状态：" >
            <el-input v-model="cardInfo.xkStatus===0?'未销户':'已销户'"  disabled />
          </el-form-item>
      </el-form>
      <el-form label-width="120px" style="margin-top: 2%">
        <el-form-item label="通信历史记录：" style="font-weight: 600; margin-bottom: 10px;">
          <div style="width: 100%; border: 1px solid rgba(210,137,255,0.2); border-radius: 4px;">
            <el-table
                    :data="cardInfo.cmppClient"
                    style="width: 100%"
                    :show-header="true"
                    size="small"
                    :cell-style="{padding: '8px 12px'}"
                    :header-cell-style="{
          background: 'rgba(210,137,255,0.1)',
          color: '#606266',
          fontWeight: '600',
          padding: '10px 12px'
        }">

              <el-table-column
                      prop="cmppTime"
                      label="发送/接收时间"
                      width="160">
              </el-table-column>

              <el-table-column
                      prop="cmppType"
                      label="通讯方式"
                      width="100">
                <template #default="scope">
            <span :style="{
              color: scope.row.cmppType === '发送' ? '#67C23A' : '#409EFF',
              fontWeight: '500'
            }">
              {{ scope.row.cmppType }}
            </span>
                </template>
              </el-table-column>

              <el-table-column
                      prop="cmppContent"
                      label="结果ID"
                      show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                      prop="cmppContents"
                      label="短信内容"
                      show-overflow-tooltip>
              </el-table-column>
            </el-table>

            <div
                    v-if="!cardInfo.cmppClient || cardInfo.cmppClient.length === 0"
                    style="text-align: center; padding: 40px; color: #909399;">
              暂无通信记录
            </div>
          </div>
        </el-form-item>
      </el-form>

    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="openBalanceDis" class="class_dialog_hospital" width="30%">
      <template slot="title">
        <span>余额{{yueDesc}}操作</span>
      </template>
      <span style="font-size:15px;">当前卡号余额：<strong style="color: red;font-size:17px;">{{balanceInfo.balance+' 元'}}</strong></span>
      <div style="display:flex;align-items: center;font-size:15px;margin-top: 10px;">
        <div>{{yueDesc}}余额：</div>
        <div>
          <el-input placeholder="请输入整数或小数" type="number" @change.native="changeAdb" v-model="adb" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openBalanceDis=false">取 消</el-button>
        <el-button size="small" type="primary" @click.stop="saveBalance(balanceInfo.iccid,yueDesc)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="openPayPass" title="查看支付密码" class="class_dialog_hospital" width="30%">
      <div style="margin-bottom:5px;">
        <span style="font-size: 14px;">当前卡号微信支付密码：</span>
        <span style="font-size: 17px;color: #FF0000;font-weight: 700;" v-if="paySign===null">未生成密码</span>
        <span style="font-size: 17px;color: #FF0000;font-weight: 700;" v-if="paySign!=null">{{paySign}}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openPayPass=false">取 消</el-button>
      </div>
    </el-dialog>

    <!--导出卡详细功能-->
    <el-dialog :close-on-click-modal="false" :visible.sync="importCardInfo" title="选择导出字段" class="class_dialog_hospital" width="40%">
      <el-checkbox-group v-model="checkList" @change="handlerCheck">
        <el-checkbox disabled checked label="iccid">我方卡号</el-checkbox>
        <el-checkbox disabled checked label="cardNo">真实号码</el-checkbox>
        <el-checkbox disabled checked label="cardDefineNo">自定义号码</el-checkbox>
        <el-checkbox disabled checked label="packageName">套餐名称</el-checkbox>
        <el-checkbox disabled checked label="agentName">代理商名</el-checkbox>
        <el-checkbox disabled checked label="cardTypeName">通道</el-checkbox>
        <el-checkbox disabled checked label="agentId">代理商ID</el-checkbox>
        <el-checkbox disabled checked label="status">卡状态</el-checkbox>
        <el-checkbox disabled checked label="isRealname">实名状态</el-checkbox>
        <el-checkbox disabled checked label="balance">卡余额</el-checkbox>
        <el-checkbox disabled checked label="used">已用量</el-checkbox>
        <el-checkbox disabled checked label="remain">剩余量</el-checkbox>
        <el-checkbox disabled checked label="paySign">微信支付密码</el-checkbox>
        <el-checkbox disabled checked label="isMaxUsed">达量断网阈值（MB）</el-checkbox>
        <el-checkbox disabled checked label="isLimitRule">限速规则（MB）</el-checkbox>
        <!--<el-checkbox label="agentIdOne">一级代理名称</el-checkbox>-->
        <el-checkbox label="startTime">套餐首充时间-套餐结束时间</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="importCardInfo=false">取消</el-button>
        <el-button size="small" type="primary" @click="stratImport">确定</el-button>
      </div>
    </el-dialog>


    <el-drawer
            :visible.sync="taocanBox"
            direction="btt"
            size="80%"
            :modal="false"
            :destroy-on-close="true"
            :close-on-press-escape="false"
            >
      <div style="padding: 50px">
        <card_packet_desc_info style="margin-top: -50px" :chuanname="chuanname" :chuaniccid="chuaniccid"></card_packet_desc_info>
      </div>

    </el-drawer>

  </div>
</template>

<script>
import Pagination from '../../../components/pagination'
import tools from '../../../utils/tools'
import {aesEncrypt} from '../../../utils/mycrypto'
import allocPackage from '../../../components/alloc_package'
import card_packet_desc_info from "../../../components/card_packet_desc_info";

export default {
  name: 'card',
  components: {
    Pagination,allocPackage,card_packet_desc_info
  },
  props:{
    openid: String,
  },

  mounted: function () {
    let _this = this
    _this.loadType()
    _this.loadRoute()
    _this.loadAgent()
    _this.find_classification()
    let user = JSON.parse(sessionStorage.getItem('loginUser'))
    _this.username = user.userName
    _this.roleId =_this.$loginUser.roleId

    _this.headers={
      token: sessionStorage.getItem("sys-token"),
      userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
    }
    _this.queryParams.indexType=_this.$route.query.type
    _this.queryParams.openid=_this.openid
    _this.list(1)

  },
  data() {

    let checkNumber = (rule, value, callback) => {
      let _this = this
      if (!_this.$check.checkNumber(value)) {
        return new callback(new Error('请输入数字'))
      } else {
        callback()
      }
    }

    return {
      roleId: '',
      aollpackey: Math.random(100)*100,
      headers:{},
      checkList:[],
      checkListId: [],
      packetTableData: [],
      clearInt: null,
      progress: 0,
      userName: '',
      importCardInfo: false,
      diaVisDrawCard: false,
      maxHeight: 500,
      pressnum: 0,
      importUrl: this.$modelUrl+'/导卡入库.xlsx',
      openUpdInfo: false,
      updInfo: {
        iccids: '',
        classification:'',
        remarks: '',
      },
      openRefund: false,
      SetMealImport: false,
      timer: null,
      agentBe: '',
      status: '',
      xkStatus: '',
      input_start: '',
      input_end: '',
      paySign: '',
      yueDesc: '',
      adb: 0.0,
      balanceInfo: {},
      openBalanceDis: false,
      iotVoice: '0',
      openUsedFlowDis: false,
      loading: false,
      openPayPass: false,
      dayHis: {},
      monHis: {},
      iccid: '',
      cardInfo: {},
      cardInfoDis: false,
      modelDiyBalance: '',
      active_text: '是否开启自定义金额设置',
      showDiyBalance: false,
      showDiyBalance_count: false,
      showBuyBalance: false,
      diyBalance: false,
      //uploadIccidDis: false,
      uploadClass: false,
      uploadUrl: process.env.VUE_APP_SERVER + '/manager/uploadExcel',
      resourceForm: {
        cardTypeName: '',
        cardTypeCode: ''
      },
      rules: {
        cardTypeName: [{ required: true, message: '请输入中文资源名:如济南电信', trigger: 'blur' }],
        cardTypeCode: [{ required: true, message: '例如：电信资源=..dx/移动资源=..yd/联通资源=..lt/广电资源=..gd', trigger: 'blur' }]
      },
      diaVisCard: false,
      deletecardModel: false,
      limitNum: 1,
      fileList: [],
      diaVisImport: false,
      oneCardType: '',
      agents: [],
      agent: '',
      dialogFormVisible: false,
      multipleSelection: [],
      classification_list: [],
      classification: '',
      tableData: [],
      input_value: window.sessionStorage.getItem('input_value') || '',
      cards: {},
      cardType: '',
      isDisabled: true,
      cardTypeList: [],
      iccids: '',
      selIccid: [],
      find_PacketData: [],
      FlowData: [],

      De_val: '0',
      isShow: false,
      MuShow: true,
      typeWh: '',
      Undivided: '未划分通道',
      wu: '无',
      no: '否',
      yes: '是',
      unrealname: '未实名',
      underreview: '审核中',
      realname: '已实名',
      maliciousrealname: '恶意实名',
      yesxkStatus: '已销户',
      noxkStatus: '未销户',
      disnetworkStatus: '断网状态',
      opennetworkStatus: '开网状态',

      cardjs: require("../../../api/card"),
      cardTypeJs: require("../../../api/cardType"),
      agentjs: require("../../../api/agent"),
      packetjs: require("../../../api/packet"),
      couponjs: require("../../../api/coupon"),
      cardRouteJs: require("../../../api/cardRoute"),
      serviceProcessjs: require("../../../api/serviceProcess"),
      queryParams:{
        shouchong: '0',
        iot:'',
        orderByName: '',
        orderBy: '',
        current: 1,
        size: 10,
        cardType: '',
        number: '',
        agentId:'',
        status: '',
        startIccid: '',
        endIccid: '',
        agentBe: '',
        classification: '',
        Remarks: '',
        iccid:'',
        relatedCdId:'',
        indexType:'',
        openid:'',
      },
      cardTypes:[],
      cardRoutes:[],
      taocanBox: false,
      chuaniccid:'',
      chuanname:'',
      packageId:'',
      sendSms:{
        phone:'',
        content:'',
      },
    }
  },

  created() {
  },
  methods: {
    toDiasrelin(iccid){
      this.$router.push({
        path: 'connectionDiagnosis',
        query: {
          iccid: iccid
        }
      })
    },
    allocopen(){
      this.aollpackey =this.aollpackey +1
      this.diaVisDrawCard = true
    },
    loadAgent(){
      this.agentjs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agents.push(map)
        })

      })
    },
    loadType() {
      let _this = this
      _this.cardTypeJs.getCardTypeList().then(response => {
        _this.cardTypes = response.data.data
      })
    },
    loadRoute() {
      let _this = this
      _this.cardRouteJs.getCardRouteList().then(response => {
        _this.cardRoutes = response.data.data
      })
    },
    updInfoOK() {
      //修改卡信息 保存
      let _this = this
      if(_this.updInfo.iccids === ''){
        _this.$alert("请输入ICCID")
        return false
      }
      if(_this.updInfo.classification==='' && _this.updInfo.remarks===''){
        _this.$alert("两项不能都为空")
        return false
      }
      _this.$confirm('批量修改分类及备注, 是否继续?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let _this = this
                let Pwd_Str = aesEncrypt(JSON.stringify(_this.updInfo))
                _this.cardjs.updateCardInfo(Pwd_Str).then(response => {
                  if (response.data.code === '0') {
                    _this.$alert(response.data.data)
                    _this.openUpdInfo=false
                  } else {
                    _this.$alert(response.data.msg)
                  }
                  _this.list(1)
                })
              })
    },

    // 定义选择单列和去全选--开始
    selectItem(list, row) {
      this.checkListId = []
      list.map(item => {
        this.checkListId.push(item.packetId)
      })
    },
    selectAll(selection) {
      this.checkListId = []
      // 若取消全选，当前页的选中数据移除
      if (selection.length === 0) {
        const ids = this.packetTableData.map(i => {
          return i.id
        })
        for (var i = 0; i < this.checkListId.length; i++) {
          if (ids.indexOf(this.checkListId[i].id) > -1) {
            this.checkListId.splice(i, 1)
            i--
          }
        }
      }
      const arr = [...selection, ...this.checkListId]
      this.checkListId = Array.from(new Set(arr))
    },
    showToggle() {
      this.isShow = !this.isShow
    },

    sortchange(column) {
      let _this = this
      _this.queryParams.orderBy = column.order
      _this.queryParams.orderByName = column.prop
      this.list(1)
    },



    blurCardType() {
      let _this = this
      let len = _this.resourceForm.cardTypeCode.length
      let str = _this.resourceForm.cardTypeCode.substr(len - 2, len)
      if (str !== 'dx' && str !== 'yd' && str !== 'lt' && str !== 'gd') {
        _this.$notify.error('资源编码最后请以运营商小写字母结束！')
        return false
      }
      return true
    },

    optino_SetMeal(info) {
      //套餐操作
      let _this = this
      let icc =_this.roleId==='777'?info.iccid:info.cardDefineNo
      _this.chuaniccid =icc
      _this.chuanname=info.packageAgentname
      _this.taocanBox =true
      /*_this.$router.push({
        path: 'cardPacketDescInfo',
        query: {
          packetName: info.packageAgentname,
          iccid: _this.roleId==='777'?info.iccid:info.cardDefineNo
        }
      })*/
    },
    payPassWordOper(tel) {
      let _this = this
      _this.openPayPass = true
      _this.cardjs.queryPaySign(tel).then(res => {
        if (res.data.code === '0') {
          _this.paySign = res.data.data
        }
      })
    },


    handlerCommand(command) {
      let _this = this
      switch (command.command) {
        case 'upFlow':
          _this.updateFlow(command)
          break
        case 'status':
          _this.updateStatus(command)
          break
        case 'auth':
          _this.updateAuth(command.row.iccid)
          break
        case 'changeAuth':
          _this.changeAuth(command.row)
          break
        case 'on':
          _this.updateTF(command.row.iccid, 'on')
          break
        case 'off':
          _this.updateTF(command.row.iccid, 'off')
          break
        case 'plus':
          _this.updateBalance(command.row, 'plus')
          break
        case 'mins':
          _this.updateBalance(command.row, 'mins')
          break
        case 'payPassword':
          _this.payPassWordOper(command.row.iccid, 'payPassword')
          break
        case 'cleanAuth':
          _this.addServiceProcess(command.row,'清除实名')
          break
        case 'refurbishCard':
          _this.addServiceProcess(command.row,'翻新卡')
          break
        case 'deleteCard':
          _this.addServiceProcess(command.row,'删除卡')
          break
        case 'CMPPClient':
          _this.CMPPClient(command.row)
          break
      }
    },


    beforeHandleCommand(row, command, item, index, monthType) {
      return {
        row: row,
        command: command,
        item: item,
        index: index,
        monthType: monthType
      }
    },
    saveBalance(tel, type) {
      let _this = this
      let ztype = null
      if (type === '充值') {
        ztype = 'plus'
      } else {
        ztype = 'mins'
      }
      _this.cardjs.sa_bal({
          balance: _this.adb,
          iccid: tel,
          type: ztype
        })
        .then(res => {
          if (res.data.code === '0') {
            _this.$alert(res.data.data)
            _this.openBalanceDis = false
          } else {
            _this.$alert(res.data.msg)
            _this.openBalanceDis = false
          }
        })
    },

    handlerCheck() {
      let _this = this
      if(_this.checkList.length>15) {
        _this.queryParams.shouchong="1"
      }
    },


    stratImport() {
      let _this = this
      _this.importCardInfo = false
      if (_this.$check.checkIsNull(_this.queryParams.cardType)) {
        if (_this.$check.checkIsNull(_this.queryParams.iccid)) {
          _this.$alert('请先选择资源通道！')
          return false
        }
      }
      _this
        .$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.queryParams.current =1
          this.queryParams.size = _this.$refs.pagination.size
          _this.cardjs.exportExcel( this.queryParams)
            .then(res => {
              _this.$alert('已操作导出，请稍后到功能模块：业务管理中的执行任务管理下载查看！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          })
        })
    },

    exportExcel() {
      let _this = this
      if (_this.$check.checkIsNull(_this.queryParams.cardType)) {
        if (_this.$check.checkIsNull(_this.queryParams.iccid)) {
          _this.$alert('请先选择资源类型')
          return
        }
      }
      _this.importCardInfo = true
    },



    changeAdb() {
      let _this = this
      if (!_this.$check.checkNumber(_this.adb) || parseFloat(_this.adb <= 0.0)) {
        _this.$notify.error('请输入大于1的数字')
        return false
      } else {
      }
    },


    updateBalance(cardInfo, type) {
      let _this = this
      if (type === 'plus') {
        _this.yueDesc = '充值'
      } else {
        _this.yueDesc = '扣费'
      }
      _this.adb = ''
      _this.balanceInfo = cardInfo
      _this.openBalanceDis = true
    },

    updateTF(tel, type) {
      let _this = this
      let ztype = null
      if (type === 'on') {
        ztype = '复机'
      } else {
        ztype = '停机'
      }
      _this
        .$confirm('此操作将进行' + ztype + '指令操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.loading = true
          //查询当前卡的运营商状态并更新数据库状态
          _this.cardjs.changeStatus( {
                iccid: tel,
                type: type
            })
            .then(res => {
              if (res.data.code === '0') {
                _this.loading = false
                //获取到真实状态双向绑定到当前卡状态
                _this.cardInfo.status = res.data.data
                this.$alert('状态已经更新')
              } else {
                this.$message.error({
                  showClose: true,
                  message: res.data.msg,
                  type: "error",
                  duration: 0
                })
                _this.loading = false
              }
              //刷新
              _this.queryParams.number = tel
              _this.list(1)
            })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },
    updateAuth(tel) {
      let _this = this
      _this
        .$confirm('此操作将进行查询实名, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.loading = true
          //查询当前卡的运营商状态并更新数据库状态
          _this.cardjs.queryIotAuth(tel).then(res => {
            if (res.data.code === '0') {
              _this.loading = false
              //获取到真实状态双向绑定到当前卡状态
              _this.cardInfo.isRealname = res.data.data
              this.$alert(res.data.data=== 0?'未实名制':"已实名制")
            } else {
              _this.loading = false
            }
            _this.queryParams.number = tel
            _this.list(1)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },

    updateFlow(val) {
      let _this = this

      //查询当前卡的运营商状态并更新数据库状态
      _this
        .$confirm('此操作将进行更新流量, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          //_this.loading = true
          _this.tableData[val.item].remain = '更新中...'
          val.row.remain = '更新中...'
          _this.tableData[val.item].used = '更新中...'
          val.row.used = '更新中...'
          _this.tableData[val.item].totalVoice = '更新中...'
          val.row.totalVoice = '更新中'
          _this.tableData[val.item].usedVoice = '更新中...'
          val.row.usedVoice = '更新中'

          _this.$set(_this.tableData, val.row, val)
          //查询当前卡的运营商状态并更新数据库状态
          if(_this.username==='ahlt'){
            _this.cardjs.queryFlowInfoAnlt( val.row.iccid).then(res => {
              if (res.data.code === '0') {
                _this.loading = false

                let remain = res.data.data.remain.toFixed(2)
                let used = res.data.data.used.toFixed(2)
                let totalVoice = res.data.data.totalVoice
                let usedVoice = res.data.data.usedVoice
                _this.tableData[val.item].remain = remain
                val.row.remain = remain
                _this.tableData[val.item].used = used
                val.row.used = used
                _this.tableData[val.item].totalVoice = totalVoice
                val.row.totalVoice = totalVoice
                _this.tableData[val.item].usedVoice = usedVoice
                val.row.usedVoice = usedVoice
                _this.$set(_this.tableData, val.row, val)
                //获取到真实状态双向绑定到当前卡状态
                this.$alert('流量已经更新')
              } else {
                _this.loading = false
              }
            })
          }else{
            _this.cardjs.queryFlowInfo( val.row.iccid).then(res => {
              if (res.data.code === '0') {
                _this.loading = false

                let remain = res.data.data.remain.toFixed(2)
                let used = res.data.data.used.toFixed(2)
                let totalVoice = res.data.data.totalVoice
                let usedVoice = res.data.data.usedVoice
                _this.tableData[val.item].remain = remain
                val.row.remain = remain
                _this.tableData[val.item].used = used
                val.row.used = used
                _this.tableData[val.item].totalVoice = totalVoice
                val.row.totalVoice = totalVoice
                _this.tableData[val.item].usedVoice = usedVoice
                val.row.usedVoice = usedVoice
                _this.$set(_this.tableData, val.row, val)
                //获取到真实状态双向绑定到当前卡状态
                this.$alert('流量已经更新')
              } else {
                _this.loading = false
              }
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },


    updateStatus(cardInfo) {
      let _this = this
      _this
        .$confirm('此操作将进行更新状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          //_this.loading = true
          _this.tableData[cardInfo.item].status = 99
          cardInfo.row.status = 99
          _this.$set(_this.tableData, cardInfo.item, cardInfo.row)
          //查询当前卡的运营商状态并更新数据库状态
          _this.cardjs.queryStatusInfo(cardInfo.row.iccid).then(res => {
            if (res.data.code === '0') {
              _this.loading = false
              //获取到真实状态双向绑定到当前卡状态
              _this.tableData[cardInfo.item].status = res.data.data
              cardInfo.row.status = res.data.data
              _this.$set(_this.tableData, cardInfo.item, cardInfo.row)
              this.$alert('状态已经更新')
            } else {
              _this.tableData[cardInfo.item].status = 100
              cardInfo.row.status = 100
              _this.$set(_this.tableData, cardInfo.item, cardInfo.row)
              this.$alert('更新状态异常')
              _this.loading = false
            }
            _this.queryParams.number = cardInfo.row.iccid
            _this.list(1)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },
    async openCardInfo(cardInfo) {
      let _this = this
      _this.cardInfo = cardInfo
      let res =await _this.cardjs.queryAUTH(cardInfo.iccid)
        if (res.data.code === '0') {
          let auth = res.data.data.cardAuth
          if(!_this.$check.checkIsNull(auth)){
            _this.cardInfo.realName = auth.realName
            _this.cardInfo.idCardNo = auth.idCardNo
            _this.cardInfo.mobile = auth.mobile
          }
          try {
            _this.packageId = res.data.data.packetNameList[0].packageId
            _this.cardInfo.packetNameList = res.data.data.packetNameList
            _this.cardInfo.cmppClient = res.data.data.cmppClient
          } catch (e) {
          }
          _this.cardInfoDis = false
          _this.cardInfoDis = true
        } else {
          _this.cardInfo.realName = ''
          _this.cardInfo.idCardNo = ''
          _this.cardInfo.mobile = ''
        }
      _this.cardInfoDis = true
    },


    resetForm(form) {
      this.queryParams =this.$options.data().queryParams
    },



    find_classification() {
      let _this = this
      let map={
        agentId: _this.$loginUser.agentId
      }
      _this.cardjs.find_classification(map).then(res=>{
        if (res.data.code === '0') {
          _this.classification_list = res.data.data
        }
      })


    },
    saveResource(form) {
      let _this = this
      if (!_this.blurCardType()) {
        _this.$alert('资源编码格式错误')
        return false
      }
      _this.$refs[form].validate(valid => {
        if (valid) {
          _this.cardTypeJs.saveCardType( _this.resourceForm).then(res => {
            if (res.data.code === '0') {
              _this.$alert('新建资源成功，即将跳转上传导卡...')
              _this.diaVisCard = false
              setTimeout(function () {
                _this.diaVisImport = true
              }, 3000)
            } else {
              _this.$alert(res.data.msg)
            }
            _this.$refs.upload.clearFiles()
          })
        } else {
          _this.$alert('表单验证失败')
          _this.$refs.upload.clearFiles()
          return false
        }
      })
    },
    importCard() {
      this.$confirm('当前要导入的这批卡是否已经存在过资源?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          this.diaVisCard = false
          this.diaVisImport = true
        })
        .catch(() => {
          this.diaVisCard = true
          this.diaVisImport = false
        })
    },

    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.queryParams.current =page
      _this.queryParams.size = _this.$refs.pagination.size
      _this.tableData = []

      _this.cardjs.getCardList( _this.queryParams)
        .then(response => {
          if (response.data.code === '0') {
            _this.tableData = response.data.data.rows
            _this.typeWh = response.data.data.rows[0].cardType
            _this.$refs.pagination.render(page, response.data.data.total)
          } else {
            this.$alert('未找到查询数据')
          }
        })
    },




    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      let _this = this
      clearInterval(_this.timer)
      if (res.code === '0') {
        this.$alert(res.data)
      } else {
        this.$alert(res.msg)
        this.$refs.upload.clearFiles()
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      let _this = this
      clearInterval(_this.timer)
      this.alert.error('文件上传失败')

      this.$refs.upload.clearFiles()
    },



    uploadFile() {
      this.$refs.upload.submit()
    },
    addServiceProcess(row,operationName){
      let _this = this
      _this.$confirm('请确定是否'+operationName+'？</br><span style="color: red">注:清除实名操作（官方+智树实名信息）；翻新卡操作清除所有记录只保留卡列表 ；删除卡操作删除所有记录（卡列表，订单，流量，历史，ic，实名，分润）。</span>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        let data={
          iccid: row.iccid,
          operationName:operationName
        }
        _this.serviceProcessjs.addServiceProcess(data)
                .then(res => {
                  _this.$alert('已操作，请等待审核！')
                })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消！'
        })
      })
    },


    CMPPClient(row) {
      let _this = this

      // HTML 转义，避免短信内容里的 < > 被当成 HTML 标签解析
      const escapeHtml = (str) => {
        return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
      }

      _this.$prompt('请输入短信内容', '发送短信', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPlaceholder: '请输入短信内容...',
        inputValidator: (value) => {
          if (!value || value.trim() === '') {
            return '短信内容不能为空'
          }
          if (value.length > 500) {
            return '短信内容不能超过500个字符'
          }
          return true
        }
      }).then(({ value }) => {
        // 转义 + 换行处理，保证内容正常显示
        const safeContent = escapeHtml(value).replace(/\n/g, '<br/>')

        // 第一步确认后，进行二次确认
        _this.$confirm(
                `请确认是否发送短信？<br/><span style="color: red">触发激活。</span><br/>手机号：${row.cardNo}<br/>短信内容：${safeContent}`,
                '确认发送',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  dangerouslyUseHTMLString: true,
                  type: 'warning'
                }
        ).then(() => {
          // 用户确认发送
          _this.sendSms.phone = row.cardNo
          _this.sendSms.content = value
          _this.serviceProcessjs.CMPPClient(_this.sendSms)
                  .then(res => {
                    _this.$alert(res.data.data)
                  })
                  .catch(err => {
                    _this.$message.error('发送失败：' + (err.message || '未知错误'))
                  })
        }).catch(() => {
          _this.$message.info('已取消发送')
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消！'
        })
      })
    },

    changeAuth(row) {
      let _this = this
      _this.loading = true
      let statusName = '【空】'
      if (row.isRealname === 0) {
        statusName = '未实名'
      }
      if (row.isRealname === 2) {
        statusName = '已实名'
      }
      _this
        .$confirm('温馨提示  当前状态为【' + statusName + '】此操作将进行修改实名, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.cardjs.changeAuth(row.iccid).then(res => {
            if (res.data.code === '0') {
              _this.loading = false
              //获取到真实状态双向绑定到当前卡状态
              _this.cardInfo.isRealname = res.data.data.data
              this.$message({
                type: 'success',
                message: res.data.data.message
              })
            } else {
              _this.loading = false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
          _this.loading = false
        })
    }
  }
}
</script>



<style lang="less" scoped>

  /* 自定义样式类 */
  .custom-message-box {
    width: 60%; /* 设置为所需的宽度 */
  }


  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }


  /deep/.el-table .cell {
    line-height: 40px;
  }
  /deep/.el-table .el-table__cell {
    padding: 0px;
  }
  .el-form-item__label .wrapper {
    color: red;
  }



  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }


  ::v-deep .el-button-group .el-button {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
}


.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}



/* --------------------------弹窗样式------------------------------ */
/*标题样式*/
/deep/.class_dialog_hospital .el-dialog__title {
  font-size: 15px;
  margin-left: 15px;
}

/*头区样式*/
/deep/.class_dialog_hospital .el-dialog__header {
  height: 50px;
  background: #e6e6e6;
  padding: 15px 0 4px 10px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}

/*头区退出按钮样式*/
/deep/.class_dialog_hospital .el-dialog__headerbtn {
  top: 14px;
  right: 20px;
  font-size: 16px;
}

/*对话框区*/
/deep/.class_dialog_hospital .el-dialog {
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 4px #e6e6e6;
  border-radius: 9px;
  padding: 0;
}

/*内容区*/
/deep/.class_dialog_hospital .el-dialog__body {
  padding: 20px;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: 700;
}

/*脚区*/
/deep/.class_dialog_hospital .el-dialog__footer {
  border-top: 2px solid #e8eaec;
  padding: 16px;
}
.row {
  display: flex;
  align-items: center;
}
  ::v-deep .el-table__fixed-body-wrapper{
    height: calc(100% - 48px ) !important;
  }

</style>
